import { Link } from "react-router-dom";
import {
  Card,
  CardMedia,
  CardActionArea,
  CardContent,
  Typography,
  Divider,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import defaultImage from "../images/default-image.png";

const styles = {
  root: {
    maxWidth: 280,
  },
  rootMobile: {
    width: 280
  },
  img: {
    height: 248,
    objectFit: "contain",
  },
  cardContent: {
    height: 180,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
  },
};

const parseId = (id) => {
  return id.replace(/\//g, " - ");
};

export default function ProductCard({ product }) {
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  const randomQueryString = Math.random().toString(36).substring(7);

  const src = `${process.env.PUBLIC_URL}/assets/Catalogo/${parseId(
    product?.productId
  )}.jpg?${randomQueryString}`;

  const description =
    product.productDescription.length > 40
      ? `${product.productDescription.substring(0, 40)}...`
      : product.productDescription;

  return product.length === 0 ? (
    <CircularProgress />
  ) : (
    <Card style={mobile ? styles.rootMobile : styles.root} raised={true} elevation={3}>
      <CardActionArea
        component={Link}
        to={{
          pathname: `/product-details/${encodeURIComponent(product.productId)}`,
        }}
      >
        <CardMedia
          component="img"
          image={src}
          onError={(e) => {
            e.target.src = defaultImage;
          }}
          title={product.productDescription}
          style={styles.img}
        />
        <CardContent style={styles.cardContent}>
          <Typography variant="h5">{product.productId}</Typography>
          <Typography variant="subtitle1" display="block" height={56}>
            {description}
          </Typography>
          <Divider />
          <Typography>
            <strong>${product.unitPrice}</strong>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
